<template>
  <div class="general-form-wrap scouting-image-wrap">
    <div class="general-form">
      <a-form layout="horizontal" :form="form" @submit="handleSubmit">
        <div class="image-upload box-wrapper">
          <div class="heading">
            <h2 class="form-title">Scouting Images (Up to 2)</h2>
          </div>
          <a-form-item>
            <div class="dropbox">
              <BaseDragUpload
                multiple
                :upload-limit="2"
                class="drag-image-wrapper"
                :preview-images="athlete.images"
                @file-delete="handleFileDelete"
                @file-upload="image => handleImageUpload(image)"
              />
            </div>
          </a-form-item>
        </div>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            class="next-button first-save-button "
            >Save And Continue</a-button
          >
          <a-button
            type="primary"
            @click="handleStepSkip"
            class="next-button second-skip-button"
            >Skip</a-button
          >
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

const STORE_KEY = "playerStore";
const ATHLETE_STORE_KEY = "athleteStore";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
  name: "ScoutingImages",
  data() {
    return {
      previewVisible: false,
      previewImage: "",
      fileList: [],
      imageList: [],
      hasErrors,
      form: this.$form.createForm(this)
    };
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
      this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
        id: this.athleteId
      });
    });
  },
  computed: {
    athleteId() {
      return this.id || this.$route.params.id;
    },
    ...mapGetters({
      athlete: `${ATHLETE_STORE_KEY}/athlete`
    })
  },
  methods: {
    validateForm() {
      return true;
    },
    handleStepSkip() {
      this.$emit("save", 4);
    },
    handleImageUpload(image) {
      this.imageList = image;
    },
    handleFileDelete(data) {
      this.$store.dispatch(`${ATHLETE_STORE_KEY}/deleteAthleteImages`, {
        id: this.athleteId,
        data: data
      });
    },
    ...mapActions({
      addPlayerImages: `${STORE_KEY}/addPlayerImages`
    }),
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },

    // Upload functions
    handleCancel() {
      this.previewVisible = false;
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.thumbUrl;
      this.previewVisible = true;
    },

    handleUploadChange(info) {
      let fileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      fileList = fileList.slice(-2);

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          // file.url = file.response.url;
          file.url = file.thumbUrl;
          file.response.name = file.name;
          file.response.thumbUrl = file.thumbUrl;
          file.response.url = file.thumbUrl;
        }
        return file;
      });

      this.fileList = fileList;

      const status = info.file.status;
      if (status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },

    // Submit value
    async handleSubmit(e) {
      e.preventDefault();
      if (!_.isEmpty(this.imageList)) {
        let images = new FormData();
        this.imageList.forEach((item, index) =>
          images.append(`file${index}`, item)
        );
        images.append("slug", "athlete");
        images.append("id", this.athleteId);
        await this.$store.dispatch(
          `${ATHLETE_STORE_KEY}/uploadScoutingImages`,
          images
        );
      }
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/updateAthlete`, {
        id: this.athleteId,
        registerPageCompleted: 4,
        slug: "athlete"
      });
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
        id: this.athleteId
      });
      this.$emit("save", this.athlete.registerPageCompleted);
    }
  }
};
</script>
<style lang="scss">
.general-form-wrap {
  .heading {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-bottom: 60px;
    .form-title {
      width: fit-content;
      text-transform: uppercase;
      font-size: 18px;
      color: #4f5152;
      position: relative;
      padding-left: 10px;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: #d23129;
      }
    }
  }
  .general-form {
    // max-width: 600px;
    margin: 0 auto;
    .general-info {
      margin-bottom: 60px;
    }
    .image-upload {
      background: #d23129 !important;
      .heading {
        .form-title {
          color: #ffffff;
          &::before {
            background: #ffffff;
          }
        }
      }
    }
  }
  .dropbox {
    > span {
      display: flex;
      flex-direction: row-reverse;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .ant-upload {
        &.ant-upload-drag {
          max-width: 400px;
          margin: 0 20px;
          width: 50%;
        }
        .ant-upload-btn {
          padding: 30px 0;
        }
      }
      .ant-upload-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        max-width: 50%;
        .ant-upload-list-picture-card-container {
          width: 150px;
          height: 150px;
          margin-bottom: 0;
          .ant-upload-list-item {
            width: 150px;
            height: 150px;
            padding: 3px;
          }
        }
        .ant-upload-list-item-thumbnail {
          opacity: 1;
        }
        .ant-upload-list-item-actions {
          width: 100%;
          display: flex;
          justify-content: space-around;
          .anticon {
            font-size: 22px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .general-form-wrap {
    .heading {
      margin-bottom: 40px;
    }
  }
}

@media only screen and (max-width: 575px) {
  .general-form-wrap {
    .heading {
      margin-bottom: 20px;
      .form-title {
        font-size: 16px;
      }
    }
  }
}
</style>
